// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';

const defaultState = {
  pii: {},
  error: null
};

export default function piiReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.pii.ACTION_TYPES.PII_COLLECTED:
      const updatedPii = { ...state.pii };
      action.payload.forEach((newPii) => {
        updatedPii[newPii.patientId] = newPii;
      });

      return {
        ...state,
        pii: updatedPii,
        loading: false
      };
    case actions.pii.ACTION_TYPES.ADD_PATIENTS:
      const newPii = {};
      action.payload.forEach((patientId) => {
        if (!state.pii[patientId]) {
          newPii[patientId] = {
            piiFetched: false,
            patientId: patientId,
            name: '[encrypted]',
            hcn: '[encrypted]',
            dob: '[encrypted]',
            postal: '[encrypted]'
          };
        }
      });
      return {
        ...state,
        pii: { ...state.pii, ...newPii },
        loading: false
      };
    case actions.encryption.ACTION_TYPES.ERROR:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
}
